import { API_BASE, apiSlice } from '../../redux/api-slice'
import type { SearchResultItem } from '../search/types'
import type {
  HasPartialMediaResponse,
  MediaFileRequest,
  MediaOptionsResponse,
} from './types'

const MEDIA_URL = `${API_BASE}media`
const MEDIA_FILE_URL = `${API_BASE}mediafile`

export const mediaApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getMediaFile: build.query<string, MediaFileRequest>({
      query: ({ mediaCode, fileName }) => ({
        url: `${MEDIA_FILE_URL}/${mediaCode}/${fileName}`,
        responseHandler: async (response) => {
          if (response.ok) return response.blob()
        },
      }),
      transformResponse: (blob: Blob) => URL.createObjectURL(blob),
    }),
    getSingleMedia: build.query<SearchResultItem, MediaCode>({
      query: (mediaCode: string) => ({
        url: `${MEDIA_URL}/${mediaCode}`,
      }),
      providesTags: (_result, _error, mediaCode) => {
        if (mediaCode) {
          return [{ type: 'Media', id: mediaCode }, 'Media']
        } else {
          return ['Media']
        }
      },
    }),
    getMediaOptions: build.query<MediaOptionsResponse, void>({
      query: () => ({ url: `${MEDIA_URL}/filterOptions` }),
      providesTags: ['MediaOptions'],
    }),
    getHasPartialMedia: build.query<HasPartialMediaResponse, void>({
      query: () => ({
        url: `${MEDIA_URL}/HasPartial`,
      }),
      providesTags: ['HasPartialMedia'],
    }),
    purgeMedia: build.mutation({
      query: (mediaCode: MediaCode) => ({
        url: `${MEDIA_URL}/Purge/${mediaCode}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['HasPartialMedia'],
    }),
  }),
})

export const {
  useGetMediaFileQuery,
  useLazyGetMediaFileQuery,
  useLazyGetSingleMediaQuery,
  useGetMediaOptionsQuery,
  useLazyGetHasPartialMediaQuery,
  usePurgeMediaMutation,
} = mediaApi
